import { NMAppDataStore } from "@neumetric/blueprint-lib/store";

const HOST_SERVER = process.env.REACT_APP_API_SERVER || "http://localhost:3000";
const store = new NMAppDataStore(HOST_SERVER);

export * from "./documents";
export * from "./education";
export * from "./continuer";
export * from "./guide";
export * from "./arc";
export * from "./mitigator";
export * from "./auditor";

export function createAppStore() {
  store.initAppState();
  store.initSessionState();
  store.initCommonState();
  return store.createStore();
}
